package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

/**
 * Mirror de `ClanGameDetailsDTO` do backend:
 * `{ game, owners, matches, stats }`. Campos flat do jogo ficam em [game].
 */
@Serializable
data class GameDetailDTO(
    val game: GameDetailGameDTO,
    val owners: List<GameDetailOwnerDTO> = emptyList(),
    val matches: List<GameDetailMatchDTO> = emptyList(),
    val stats: GameDetailStatsDTO? = null
)

/** Mirror de `ClanGameDTO` do backend. */
@Serializable
data class GameDetailGameDTO(
    val id: Long,
    val catalogGameId: Long? = null,
    val name: String,
    val imageUrl: String? = null,
    val minNumberOfPlayers: Int? = null,
    val maxNumberOfPlayers: Int? = null,
    val bggUrl: String? = null,
    val manualUrl: String? = null,
    val spotifyUrl: String? = null,
    val gameDuration: Int? = null,
    val gameCategoryId: Long? = null,
    val categoryName: String? = null,
    val gameModeId: Long,
    val modeName: String? = null,
    val matchesPlayed: Long = 0L,
    val status: Int = 1,
    val clanId: Long,
    val bggId: Int? = null,
    val yearPublished: Int? = null,
    val thumbnailUrl: String? = null,
    val bggRank: Int? = null,
    val ratingAverage: Double? = null,
    val complexityAverage: Double? = null
)

@Serializable
data class GameDetailOwnerDTO(
    val id: Long,
    val name: String,
    val imageUrl: String? = null,
    val nickname: String? = null,
    val birthday: String? = null,
    val phone: String? = null,
    val status: Int = 1,
    val clanId: Long
)

@Serializable
data class GameDetailMatchDTO(
    val id: Long,
    val date: String,
    val duration: Int,
    val game: GameDetailMatchGameDTO,
    val players: List<GameDetailMatchPlayerDTO> = emptyList(),
    val clanExpansionIds: List<Long> = emptyList()
)

@Serializable
data class GameDetailMatchGameDTO(
    val id: Long,
    val catalogGameId: Long? = null,
    val name: String,
    val imageUrl: String? = null
)

@Serializable
data class GameDetailMatchPlayerDTO(
    val id: Long,
    val name: String,
    val nickname: String? = null,
    val imageUrl: String? = null,
    val points: Double
)

/** Mirror de `ClanGameStatsDTO`. */
@Serializable
data class GameDetailStatsDTO(
    val matchesPlayed: Long,
    val matchesPlayedCurrentYear: Long
)
